import React from 'react'
import SimpleModal from './SimpleModal'

type Props = {
    open: boolean
    onClose: () => void
    onConfirm: () => void
    title: string
    body: React.ReactNode
    confirmLabel: string
    danger?: boolean
    loading?: boolean
}

/**
 * A small confirm/cancel dialog.
 *
 * `danger` styles the confirm button red.
 *
 * */
export default function ConfirmDialog(props: Props) {
    const { open, onClose, onConfirm, title, body, confirmLabel, danger, loading } = props
    return (
        <SimpleModal open={open} onClose={onClose}>
            <div className="w-[460px] max-w-[92vw] rounded-xl bg-white text-left shadow-2xl">
                <div className="border-b border-ink-100 px-5 py-4">
                    <h3 className="m-0 font-sans text-lg font-medium text-ink-900">{title}</h3>
                </div>
                <div className="px-5 py-4 text-sm text-ink-600">{body}</div>
                <div className="flex items-center justify-end gap-2 border-t border-ink-100 bg-ink-50 px-5 py-3.5">
                    <button
                        type="button"
                        onClick={onClose}
                        className="rounded-lg border border-ink-200 bg-white px-4 py-2 text-sm font-semibold text-ink-700 hover:bg-ink-50"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={loading}
                        className={`rounded-lg px-4 py-2 text-sm font-bold text-white disabled:opacity-50 ${
                            danger ? 'bg-severe hover:opacity-90' : 'bg-arwen-600 hover:bg-arwen-700'
                        }`}
                    >
                        {loading ? 'Working…' : confirmLabel}
                    </button>
                </div>
            </div>
        </SimpleModal>
    )
}
